import css from "../assets/skills/css-3.svg"
import html from "../assets/skills/html-5.svg"
import node from "../assets/skills/nodejs.svg"
import react from "../assets/skills/react.svg"
import express from "../assets/skills/express.svg"
import tailcss from "../assets/skills/tailwindcss-icon.svg"
import mongo from "../assets/skills/mongodb.svg"
import mysql from "../assets/skills/mysql-6.svg"



// eslint-disable-next-line import/no-anonymous-default-export
export default {
  html,
  css,
  node,
  express,
  react,
  tailcss,
  mongo,
  mysql
}